import ICommand from '../../FrontApplet/Command/ICommand';
import { ITypedCommandEvent } from '../../FrontApplet/Command/ICommandEvent';
import FrontApplet from '../../FrontApplet/FrontApplet';
import {
	DisplayGetCapabilitiesRequest,
	DisplayGetCapabilitiesResult,
	DisplayRequests,
	DisplaySupportsRequest,
	DisplaySupportsResult,
} from './displayCommands';

export function handleDisplayRequests(
	onCommand: (callback: (commandEvent: ITypedCommandEvent<DisplayRequests>) => Promise<void>) => void,
	dispatch: <TCommand extends ICommand>(command: TCommand) => Promise<void>,
	frontApplet: FrontApplet,
) {
	onCommand(async (commandEvent: ITypedCommandEvent<DisplayRequests>) => {
		switch (commandEvent.command.type) {
			case DisplaySupportsRequest:
				await dispatch<DisplaySupportsResult>({
					type: DisplaySupportsResult,
					supports: await frontApplet.display.supports(commandEvent.command.capability),
				});
				break;
			case DisplayGetCapabilitiesRequest:
				await dispatch<DisplayGetCapabilitiesResult>({
					type: DisplayGetCapabilitiesResult,
					result: await frontApplet.display.getCapabilities(),
				});
				break;
			default:
		}
	});
}
